// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Sok7","notes":"Notes_notes__3HnPs","note":"Notes_note__2l3lG","markdown":"Notes_markdown__15QKW"};